import { render, staticRenderFns } from "./messageCollect.vue?vue&type=template&id=fbc69478&scoped=true"
import script from "./messageCollect.vue?vue&type=script&lang=js"
export * from "./messageCollect.vue?vue&type=script&lang=js"
import style0 from "./messageCollect.vue?vue&type=style&index=0&id=fbc69478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc69478",
  null
  
)

export default component.exports